@let controlValue = control();
@if (controlValue) {
  <mat-form-field appearance="outline" class="form-field">
  <mat-label>{{label()}}</mat-label>
    <input
      [formControl]="controlValue"
      matInput
      [owlDateTime]="dt"
      [owlDateTimeTrigger]="dt"
      [selectMode]="selectMode()"
      [max]="max()"
      [min]="min()"
      [rangeSeparator]="'-'"
      [required]="required()"
      [placeholder]="placeholder()"
      [errorStateMatcher]="errorStateMatcher()"
    />
    <owl-date-time #dt [startAt]="startAt()"></owl-date-time>
    <mat-error>{{error()}}</mat-error>
  </mat-form-field>
}
